// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"8f060031","472":"e1690a34","488":"5d648ff5","680":"5b8ae82e","805":"4f2f57b6","888":"4821fc2a"}[chunkId] + ".chunk.js";
};